export class Guid {
  static readonly Empty='00000000-0000-0000-0000-000000000000';
}

export class StringUtils {
  static readonly EMPTY="";
}
